$(document).ready(function(){
  var $slider = $('.quotes-slider');
  var slideCount = $slider.children().length;
  var isMobile = window.innerWidth < 989;

  var showDots = (isMobile && slideCount > 1) || (!isMobile && slideCount > 3);

  $slider.slick({
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: isMobile ? 1 : 3,
    arrows: false,
    dots: showDots,
    infinite: true,
    autoplay: false,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: slideCount > 1
        }
      }
    ]
  });
});
